module.exports = __webpack_public_path__ + "static/media/lahore.555cc357.svg";